export const getPaths = (prefix = '', path) => {
  if (!prefix) return path
  if (typeof path === 'string') {
    return `${prefix}${path}`
  }
  if (Array.isArray(path)) return path.map((itemPath) => `${prefix}${itemPath}`)

  return path
}
